// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import indexDBStorage from 'redux-persist-indexeddb-storage';
import { encryptTransform } from 'redux-persist-transform-encrypt';

// project import
import menu from 'store/reducers/menu';
import snackbar from 'store/reducers/snackbar';
import authReducer from 'store/auth';
import WebConfigReducer from 'store/Web-Config';
import Template from 'store/Template';
import Customer from 'store/Customer';
import Voice from 'store/Voice';
import Action from 'store/Action';
import Language from 'store/Language';
import Features from 'store/Features';
import DIDManagement from 'store/DIDManagement';
import Pricing from 'store/Pricing';
import CallType from 'store/CallType';
import LLMVendorModels from 'store/LLMVendorModels';
import Agents from 'store/Agents';
import ASRVendorModels from 'store/ASRVendorModels';
import TTSVendorModels from 'store/TTSVendorModels';
import Credentials from 'store/Credentials';
import Blog from 'store/Blog';
import Prompts from 'store/Prompts';
import SystemDefaults from 'store/SystemDefaults';
import WorkspaceAssistant from 'store/WorkspaceAssistant';
import PCM from 'store/PCM';

const VERSION = 3;
const STORE_NAME = 'vocalix_' + VERSION;

const encryptor = encryptTransform({
  secretKey: process.env.REACT_APP_SECRET_KEY || 'dev_' + STORE_NAME,
  onError: function (error) {
    // Handle the error.
    console.error('encryptTransform', error);
  }
});

const persistConfig = {
  key: 'root',
  version: VERSION,
  storage: indexDBStorage(STORE_NAME),
  // whitelist: [
  //   'auth',
  // ],
  // `prompts` holds the generator's api_key — keep it out of the persisted
  // (IndexedDB) copy; the page re-fetches it on mount anyway.
  // `systemDefaults` mirrors live platform config — a rehydrated copy would
  // show stale numbers for a beat before the fetch lands, which is the one
  // thing an operator must not see on a config screen.
  // `pcm` is live operational state (queued runs, coverage counts) and is
  // re-fetched by every PCM screen on mount — same reasoning.
  blacklist: ['feedback', 'prompts', 'systemDefaults', 'pcm'],
  transforms: [encryptor]
};

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
  menu,
  snackbar,
  auth: authReducer,
  WebConfig: WebConfigReducer,
  customer: Customer,
  template: Template,
  voice: Voice,
  action: Action,
  features: Features,
  didManagement: DIDManagement,
  language: Language,
  callType: CallType,
  pricing: Pricing,
  llmVendorModels: LLMVendorModels,
  agents: Agents,
  asrVendorModels: ASRVendorModels,
  ttsVendorModels: TTSVendorModels,
  credentials: Credentials,
  blog: Blog,
  prompts: Prompts,
  systemDefaults: SystemDefaults,
  workspaceAssistant: WorkspaceAssistant,
  pcm: PCM
});

const root = (state, action) => {
  if (action.type === 'auth/logout') {
    localStorage.removeItem('qp-inital-load');
    state = undefined;
  }
  return reducers(state, action);
};
// export default persistReducer(persistConfig, reducers);
export default persistReducer(persistConfig, root);
